/**
 * subscriptionService — Web subscription management via PayFast.
 * Calls cloud functions for checkout/cancel and reads status from Firestore.
 */

import { createWebCheckoutEurW, cancelWebSubscriptionEurW } from '../firebaseConfig';
import { getPremiumStatus } from './premiumService';
import type { PremiumStatus } from '../types/premium';

/**
 * Create a PayFast checkout and redirect the user.
 * The cloud function generates the payment URL server-side,
 * then we redirect the browser to it.
 */
export async function createCheckout(
  billingCycle: 'monthly' | 'yearly',
  successUrl: string,
  cancelUrl: string,
): Promise<void> {
  const result = await createWebCheckoutEurW({ billingCycle, successUrl, cancelUrl });
  const { url } = result.data as { url: string };
  window.location.href = url;
}

/**
 * Cancel the current web subscription via PayFast API.
 * Subscription remains active until the end of the billing period.
 */
export async function cancelSubscription(): Promise<{ cancelledAt: string; activeUntil: string }> {
  const result = await cancelWebSubscriptionEurW();
  return result.data as { cancelledAt: string; activeUntil: string };
}

/**
 * Get current subscription status (delegates to premiumService).
 */
export async function getSubscriptionStatus(uid: string): Promise<PremiumStatus> {
  return getPremiumStatus(uid);
}
